<template>
  <div class="body">
    <div class="wrapper fadeInDown">
      <div class="logo-container">
        <img src="@/assets/logo.png" id="icon" alt="User Icon" />
      </div>

    

      <div id="formContent">
        <form @submit.prevent="login">
          <i class="bi bi-person-circle icono-user"></i>
          <h3>Inicia sesión</h3>

          <input
            type="text"
            id="login"
            class="fadeIn second"
            placeholder="Usuario"
            v-model="usuario"
            aria-label="Nombre de usuario"
          />

          <input
            type="password"
            id="password"
            class="fadeIn third"
            placeholder="Contraseña"
            v-model="contraseña"
            aria-label="Contraseña"
          />
          <input
            type="submit"
            :disabled="loading"
            :class="{ 'is-loading': loading }"
            class="fadeIn fourth"
            value="Iniciar"
          />
        </form>

        <div v-if="error" id="error-msg">
          <p>{{ error_msg }}</p>
        </div>

        <div v-if="loading" id="loading-msg">
          <p>Cargando...</p>
        </div>

        <div class="col">
          <router-link to="/RecuperacionContrasena">
         ¿Olvidaste tu contraseña?
        </router-link>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginUser",
  data() {
    return {
      usuario: "",
      contraseña: "",
      error: false,
      error_msg: "",
      loading: false,
    };
  },
  methods: {
    validarFormulario() {
      if (!this.usuario || !this.contraseña) {
        this.error = true;
        this.error_msg = "Por favor, completa todos los campos.";
        return false;
      }

      if (this.contraseña.length < 5) {
        this.error = true;
        this.error_msg = "La contraseña debe tener al menos 6 caracteres.";
        return false;
      }
      return true;
    },

    login() {
      if (!this.validarFormulario()) {
        return;
      }

      this.error = false;
      this.error_msg = "";
      this.loading = true;

      const json = {
        usuario: this.usuario,
        contraseña: this.contraseña,
      };

      axios
        .post(this.$backendUrl + "validacion.php", json)
        .then((response) => {
          if (response.data.status === "ok") {
            const userRole = response.data.rol;

            // Guardar información del usuario en localStorage
            localStorage.setItem("role", userRole);
            localStorage.setItem("usuario_id", response.data.usuario_id);

            // Redirigir según el rol del usuario
            if (userRole === "administrador") {
              this.$router.push({ name: "AdminDashboard" });
            } else if (userRole === "empleado") {
              this.$router.push({ name: "EmpleadoDashboard" });
            } else {
              this.error = true;
              this.error_msg = "Rol de usuario no reconocido.";
            }
          } else {
            this.error = true;
            this.error_msg = response.data.message || "Error desconocido.";
          }
        })
        .catch((error) => {
          console.error("Error de conexión:", error);
          this.error = true;
          this.error_msg = "No se pudo conectar al servidor.";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    redirectToForgotPassword() {
      this.$router.push({ name: "RecuperacionContraseña" });
    },
  },
};
</script>

<style scoped>
.body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
  background-color: #f8ae47;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.body:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  position: relative;
}
#formContent {
  border-radius: 10px;
  background: #fff;
  padding: 30px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

.logoB {
  position: absolute;
  top: 5px;
  right: 30px;
  font-size: 30px;
  color: #000;
  text-decoration: none;
}
.logo-container {
  position: absolute;
  top: 5px;
  left: 20px;
}

#icon {
  width: 110px;
  height: 100px;
}

#error-msg {
  color: red;
  margin-top: 10px;
}

#loading-msg {
  color: blue;
  margin-top: 10px;
}
.icono-user {
  font-size: 3rem;
  color: #2c3e50; /* Color del ícono */
  display: block;
  margin: 0 auto;
  margin-bottom: 1px;
}

input[type="submit"] {
  background-color: #eabc32;
  border: none;
  color: rgb(255, 255, 255);
  padding: 15px 80px;
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  border-radius: 5px;
  margin: 5px 20px 40px 20px;
  transition: background-color 0.3s ease-in-out;
}

input[type="submit"]:hover {
  background-color: #97c335;
}

input[type="submit"]:disabled {
  background-color: #b12626;
  cursor: not-allowed;
}

input[type="password"],
input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  padding: 15px 32px;
  text-align: center;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border-radius: 5px;
  transition: border-bottom 0.5s ease-in-out;
}

input[type="password"]:focus,
input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

.fadeInDown {
  animation: fadeInDown 1s both;
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
</style>
